<template>
  <div>
    <div>
      <h3>User Information</h3>
    </div>
    <div class="wrapper" v-if="profile.authProfile.email_verified && shpoUserDto.roleList && shpoUserDto.roleList.length > 0">
        <userSignature />
    </div>
    <div class="wrapper">
      <div class="row row-wider">
        <div class="col-md-12" style="min-height: 150px;">
            <form class="form-horizontal" @submit.prevent v-if="authenticated && !hasUserRoles && shpoUserDto.otherUserAuth0Method" >
                <div v-if="!profile.authProfile.email_verified" class="alert alert-danger">
                        You have not validated your account email address.
                </div>
                <div class="from-group" style="margin-bottom: 20px;" v-else>
                    <div class="alert alert-danger">Duplicate Login Found</div>
                    <div style="margin-top: 10px; line-height: 1.5;">
                        You have attempted to log in using <b>{{authMethod}}</b>, but the email address supplied is already associated
                        with a user in the system using the <b>{{shpoUserDto.otherUserAuth0Method}}</b>.  
						Please log out of the system, then log back in using the original method used:
                        <br /><br />
                        <div v-if="shpoUserDto.otherUserAuth0Method == 'google-oauth2'" >
							To log in with a Google account, click the button labeled 'Sign in with Google'.
						</div>
                        <div v-if="shpoUserDto.otherUserAuth0Method == 'auth0'" >
							To log in with an Auth0 account, enter your email, password, and click the blue 'Log In' button.
						</div>
                        <div v-if="shpoUserDto.otherUserAuth0Method == 'windowslive'">
							To log in with a Microsoft Live Account, click the button labeled 'Sign in with Microsoft'.
						</div>
                    </div>
                </div>
            </form>
            <form class="form-horizontal" @submit.prevent v-else >
                <div class="from-group" style="margin-bottom: 20px;">
                    <div v-if="!profile.authProfile.email_verified" class="alert alert-danger">
                        You have not validated your account email address.
                    </div>
                    <div v-if="profile.authProfile.email_verified && !hasUserRoles" class="alert alert-danger">
                        You user roles have not been set up yet.
                    </div>
                </div>
                <div class="form-group" v-if="!authenticated">
                    <label class="col-sm-3 control-label text-label">authenticated</label>
                    <div class="col-sm-4 text-label">{{ this.authenticated }}</div>
                </div>
                <div class="form-group" v-if="!profile.authProfile.email_verified">
                    <label class="col-sm-3 control-label text-label">email verified</label>
                    <div class="col-sm-2 text-label">{{ profile.authProfile.email_verified ? 'Verified' : 'Not Verified' }}</div>
                    <div v-if="!profile.authProfile.email_verified" class="col-sm-3"><button class="btn btn-primary" v-on:click="sendVerifyEmail">Resend Verification Email</button></div>
                </div>
                <div class="form-group">
                    <div style="margin-left: 15px; width: 100%;">
                        <div class="alert alert-dismissible" v-bind:class="[verifyAlertHidden ? 'hidden' : '', alertType]" role="alert">
                            <button type="button" class="close" v-on:click="closeVerifyAlert()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            {{verifyAlertMessage}}
                        </div>
                    </div>
                </div>
                <div class="form-group" v-if="authenticated && !result.isValid">
                    <label class="col-sm-3 control-label text-label">valid</label>
                    <div class="col-sm-4 text-label">{{ result.isValid }}</div>
                </div>
                <div class="form-group" v-if="authenticated && !result.isValid">
                    <label class="col-sm-3 control-label text-label">errors</label>
                    <div class="col-sm-8"><ul><li v-for="item in result.messageList" :key="item.index">{{ item }}</li></ul></div>
                </div>
                <div class="form-group" v-if="authenticated" style="margin-top: 20px;">
                    <label class="col-sm-3 control-label text-label">name</label>
                    <div class="col-sm-4 text-label">{{ profile.authProfile.name }}</div>
                </div>
                <div class="form-group" v-if="authenticated">
                    <label class="col-sm-3 control-label text-label">email</label>
                    <div class="col-sm-4 text-label">{{ profile.authProfile.email }}</div>
                </div>
                <!--<div class="form-group" v-if="authenticated">
                    <label class="col-sm-3 control-label text-label">user_id</label>
                    <div class="col-sm-4 text-label">{{ profile.authProfile.sub }}</div>
                </div>-->
                <div class="form-group" v-if="authenticated">
                    <label class="col-sm-3 control-label text-label">Roles</label>
                    <div class="col-sm-8" v-if="shpoUserDto.roleList && shpoUserDto.roleList.length > 0">
                        <ul><li v-for="item in shpoUserDto.roleList" :key="item.index">{{ item }}</li></ul>
                    </div>
                    <div class="col-sm-8" v-if="!shpoUserDto.roleList || shpoUserDto.roleList.length === 0">
                        No roles assigned
                    </div>
                </div>

                <div class="form-group" v-if="authenticated">
                    <label class="col-sm-3 control-label text-label">Organizations</label>
                    <div class="col-sm-8" v-if="shpoUserDto.userOrganizationList && shpoUserDto.userOrganizationList.length > 0">
                        <ul><li v-for="item in shpoUserDto.userOrganizationList" :key="item.organizationId">{{ item.description }}</li></ul>
                    </div>
                    <div class="col-sm-8" v-if="!shpoUserDto.userOrganizationList || shpoUserDto.userOrganizationList.length === 0">
                        No organizations assigned
                    </div>
                </div>
            </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import userService from '../services/userService'
import userSignature from '../components/UserSignature'
import { mapState } from 'vuex'

export default {
    name: 'userInfo',
    components: {
        userSignature
    },
    data: function () {
        return {
            isDebug: false,
            result: [],
            verifyAlertHidden: true,
            verifyAlertMessage: '',
            alertType: 'alert-success'
        }
    },
    computed: {
        ...mapState({
            authenticated: state => state.auth.authenticated,
            profile: state => state.auth.shpoProfile,
            shpoUserDto: state => state.auth.shpoUserDto,
            authResult: state => state.auth.authResult
        }),
        hasUserRoles: function () {
            return this.shpoUserDto && this.shpoUserDto.roleList && this.shpoUserDto.roleList.length > 0
        },
        authMethod: function () {
            return this.profile && this.profile.authProfile ? this.profile.authProfile.sub.split('|')[0] : 'unknown'
        }
    },
    mounted () {
        this.result = userService.validate(this.profile, this.shpoUserDto.roleList, this.shpoUserDto.userOrganizationList)
    },
    methods: {
        sendVerifyEmail () {
            userService.sendVerifyEmail(this.$http).then(result => {
                if (result.data.isValid && result.data.objectList.length > 0) {
                    this.verifyAlertMessage = `Verification email will be sent to your email address ${this.profile.authProfile.email}. Please check your email inbox.`
                } else {
                    this.alertType = 'alert-danger'
                    this.verifyAlertMessage = 'An error has occurred with your request. Please try again later.' + result.data.isValid ? '' : result.data.messages[0]
                }
                this.verifyAlertHidden = false
            })
        },
        closeVerifyAlert () {
            this.verifyAlertHidden = true
        }
    }
}
</script>
<style>

.text-label {
    line-height: 24px !important;
}

</style>



// WEBPACK FOOTER //
// UserInfo.vue?b2506f74